import React from 'react';
import DV from 'variables/DV';
import { LIST_DOMAIN } from 'variables/staticValue';

export const getInboxCenterUrl = (inboxId) => {
  const base = `${LIST_DOMAIN[DV.partner].centerURL}?device_id=${DV.staffDeviceId}&token=${DV.token}`;
  if (inboxId) return `${base}&inbox_id=${encodeURIComponent(inboxId)}`;
  return base;
};

const secondaryStyle = {
  fontWeight: 400,
  fontSize: 12,
  lineHeight: '16px',
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
};

const InsightConversationList = ({ items }) => {
  const handleOpenInbox = (inboxId) => {
    window.open(getInboxCenterUrl(inboxId), '_blank');
  };

  return items.map((item, index) => (
    <button
      key={`${item.inbox?.id ?? 'row'}-${index}`}
      type="button"
      onClick={() => handleOpenInbox(item.inbox?.id)}
      style={{
        display: 'block',
        width: '100%',
        border: 'none',
        borderTop: index > 0 ? '1px solid #AAAAAA' : 'none',
        padding: '8px 0',
        background: 'none',
        textAlign: 'left',
        cursor: 'pointer',
      }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <span style={{ fontWeight: 600, fontSize: 12, fontFamily: 'Open Sans' }}>
          {item.inbox?.name} bởi {item.staff?.name}
        </span>
        <i className="fal fa-external-link" style={{ fontSize: 16 }} />
      </div>
      <div style={secondaryStyle}>{item.secondary}</div>
    </button>
  ));
};

export default InsightConversationList;
